import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

function Countact() {
    return (
        <Box sx={{ width: '100%', mt: 2, px: 2 }}>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', mt: 2, bgcolor: 'rgba(245, 182, 0, 0.5)', height: 50, mb: 2 }}>
                <Typography variant='h4' component={'div'} sx={{ textTransform: 'uppercase', fontWeight: 700, textDecorationLine: 'underline', textDecorationColor: 'black', ml: 3 }}>contact</Typography>
            </Box>

            <Box sx={{ width: '100%', height: 500 }}>
                <div>
                    <iframe
                        // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3661.9374817074346!2d86.195300!3d22.835580!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5e0f98b7f1955%3A0x16e80f065bf8bcd0!2sCan%20Furniture%2C%20Goush%20Nagar%2C%20Jamshedpur%2C%20Jharkhand%20831012!5e0!3m2!1sen!2sin!4v1694366720000!5m2!1sen!2sin"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d59049.52625678312!2d79.39180850053171!3d13.63359347409501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d4b0f88620427%3A0xcf4152d1daca0cac!2sTirupati%2C%20Andhra%20Pradesh!5e1!3m2!1sen!2sin!4v1783756294385!5m2!1sen!2sin"
                        width="100%"
                        height="500"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </Box>


            {/* <Box sx={{ width: '100%', bgcolor: 'rgba(245, 182, 0, 0.5)', }}> */}
            <Grid container spacing={2} sx={{ mt: 2, pb: 2 }}>
                <Grid item xs={12} sm={5} md={4} lg={4}>
                    <Box sx={{ width: '100%', bgcolor: 'rgba(245, 182, 0, 0.5)', p: 2 }}>
                        <Typography variant='h5' component={'div'} sx={{ textTransform: 'capitalize' }}>Contact Info</Typography>

                        <Box sx={{ width: '100%', display: 'flex', mb: 1 }}>
                            <Typography variant='body1' component={'div'} sx={{ textTransform: 'capitalize', fontWeight: 500, mr: 1 }}>Phone:</Typography>
                            {/* <Typography variant='body1' component={'div'} sx={{ textTransform: 'capitalize' }}>+91 80921 44414</Typography> */}
                            <Typography variant='body1' component={'div'} sx={{ textTransform: 'capitalize' }}>+91 93475 66010</Typography>
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', mb: 1 }}>
                            <Typography variant='body1' component={'div'} sx={{ textTransform: 'capitalize', fontWeight: 500, mr: 1 }}>Email:</Typography>
                            {/* <Typography variant='body2' component={'div'} sx={{ textTransform: 'capitalize' }}>canfurniture@gamil.com</Typography> */}
                            <Typography variant='body2' component={'div'} sx={{ textTransform: 'capitalize' }}>sdhrinnorworks@gmail.com</Typography>
                        </Box>
                        <Box sx={{ width: '100%', display: 'flex', mb: 1 }}>
                            <Typography variant='body1' component={'div'} sx={{ textTransform: 'capitalize', fontWeight: 500, mr: 1 }}>address:</Typography>
                            {/* <Typography variant='body2' component={'div'} sx={{ textTransform: 'capitalize' }}>Can Furniture, Goush Nagar, Jamshedpur, Jharkhand, 831012</Typography> */}
                            <Typography variant='body2' component={'div'} sx={{ textTransform: 'capitalize' }}>SDHR InnoWorks Private Limited 9/25/1 K K GUNTA, YERPEDU, Thondamanadu, Srikalahasti, Chittoor - 517641, Andhra Pradesh</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={7} md={8} lg={8}>
                    <Box sx={{ width: '100%', bgcolor: 'rgba(245, 182, 0, 0.5)', p: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <TextField
                                    type="text"
                                    id="outlined-basic"
                                    label="First Name"
                                    variant="outlined"
                                    name="classRoom"
                                    sx={{
                                        my: 1,
                                        mt: 2,
                                        background: 'rgba(245, 182, 0, 0.5)',
                                        borderRadius: 1,
                                        input: {
                                            color: 'black', // Text color
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'black', // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'black', // Border color on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'black', // Border color when focused
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'black', // Default label color
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: 'black', // Label color when focused
                                        },
                                    }}
                                    placeholder="First Name"
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <TextField
                                    type="text"
                                    id="outlined-basic"
                                    label="Last Name"
                                    variant="outlined"
                                    name="classRoom"
                                    sx={{
                                        my: 1,
                                        mt: 2,
                                        background: 'rgba(245, 182, 0, 0.5)',
                                        borderRadius: 1,
                                        input: {
                                            color: 'black', // Text color
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'black', // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'black', // Border color on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'black', // Border color when focused
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'black', // Default label color
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: 'black', // Label color when focused
                                        },
                                    }}
                                    placeholder="Last Name"
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <TextField
                                    type="email"
                                    id="outlined-basic"
                                    label="Email"
                                    variant="outlined"
                                    name="classRoom"
                                    sx={{
                                        my: 1,
                                        mt: 2,
                                        background: 'rgba(245, 182, 0, 0.5)',
                                        borderRadius: 1,
                                        input: {
                                            color: 'black', // Text color
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'black', // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'black', // Border color on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'black', // Border color when focused
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'black', // Default label color
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: 'black', // Label color when focused
                                        },
                                    }}
                                    placeholder="Email"
                                    fullWidth
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <TextField
                                    type="text"
                                    id="outlined-basic"
                                    label="Subject"
                                    variant="outlined"
                                    name="classRoom"
                                    sx={{
                                        my: 1,
                                        mt: 2,
                                        background: 'rgba(245, 182, 0, 0.5)',
                                        borderRadius: 1,
                                        input: {
                                            color: 'black', // Text color
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'black', // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'black', // Border color on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'black', // Border color when focused
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'black', // Default label color
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: 'black', // Label color when focused
                                        },
                                    }}
                                    placeholder="Subject"
                                    fullWidth
                                    required
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    type="text"
                                    id="outlined-basic"
                                    label="Last"
                                    variant="outlined"
                                    name="classRoom"
                                    sx={{
                                        my: 1,
                                        mt: 2,
                                        background: 'rgba(245, 182, 0, 0.5)',
                                        borderRadius: 1,
                                        input: {
                                            color: 'black', // Text color
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'black', // Default border color
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'black', // Border color on hover
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'black', // Border color when focused
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'black', // Default label color
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: 'black', // Label color when focused
                                        },
                                    }}
                                    placeholder="Message"
                                    fullWidth
                                    required
                                    multiline
                                    maxRows={4}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ p: 2 }}>
                                    <Button variant="outlined"
                                        sx={{
                                            mt: 2,
                                            color: 'black', // Text color
                                            borderColor: 'black', // Default border color
                                            '&:hover': {
                                                borderColor: '#f5b600', // Border color on hover
                                                backgroundColor: '#f5b600', // Background color on hover
                                                color: 'black', // Text color on hover
                                            },
                                            '&.Mui-focused': {
                                                borderColor: '#f5b600', // Border color when focused
                                            },
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </Box>
                </Grid>
            </Grid>
            {/* </Box> */}

        </Box>
    )
}

export default Countact